import React from "react";
import { Link } from "react-router-dom";
import PublicV2Layout from "./layout/PublicV2Layout";
import "./publicV2Index.css";

const PAGES = [
  { to: "/dev-preview/home", title: "Home", desc: "Hero, services, stats, real cycling reviews." },
  { to: "/dev-preview/quote", title: "Request a Quote", desc: "Full form + validation; submits to the TEST database." },
  { to: "/dev-preview/our-doors", title: "Our Doors", desc: "Recents + more transformations gallery (reuses /ba-image)." },
  { to: "/dev-preview/contact", title: "Contact", desc: "Hours, phone/text/email, social." },
  { to: "/dev-preview/privacy-policy", title: "Privacy Policy", desc: "Legal — restyled." },
  { to: "/dev-preview/terms-of-service", title: "Terms of Service", desc: "Legal — restyled." },
  {
    to: "/dev-preview/view-quote/sample",
    title: "Customer Quote (wrapper)",
    desc: "v2 chrome around the live quote display. Needs a real id+token to show data.",
  },
  {
    to: "/dev-preview/view-invoice/sample",
    title: "Customer Invoice (wrapper)",
    desc: "v2 chrome around the live invoice display. Needs a real id+token to show data.",
  },
];

const PublicV2Index = (navProps) => {
  return (
    <PublicV2Layout
      seo={{ title: "Public Pages V2 — Developer Preview" }}
      {...navProps}
    >
      <section className="bdrv2-section">
        <div className="bdrv2-container">
          <p className="bdrv2-idx-eyebrow bdrv2-accent-text">Developer Preview</p>
          <h1 className="bdrv2-idx-title">Public Pages V2</h1>
          <p className="bdrv2-idx-sub">
            One design, dark default with an on-page light/dark and background
            toggle (bottom-right). Not public — visible to developers only.
          </p>

          <div className="bdrv2-idx-grid">
            {PAGES.map((p) => (
              <Link key={p.to} to={p.to} className="bdrv2-idx-card bdrv2-glass">
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
                <span className="bdrv2-idx-go bdrv2-accent-text">View &rarr;</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </PublicV2Layout>
  );
};

export default PublicV2Index;
